export enum BlogActionItemEnum {
  Edit = 'edit_blog',
}

export enum BlogContentTabEnum {
  Posts = 'posts',
  Categories = 'categories',
}

export enum BlogPostFilterEnum {
  AllPosts = 'all_posts',
  ActivePosts = 'active_posts',
  InactivePosts = 'inactive_posts',
}
